module.exports = __webpack_public_path__ + "images/a4f9e68d3e7e396158e73feda0300b9c.png";